if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector('[name="id"]').disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        // Get the initial prices from the data attributes
        this.price = parseFloat(this.getAttribute("data-price")) || 0; // Get the initial prices from the data attributes
        this.comparePrice =
          parseFloat(this.getAttribute("data-compare-price")) || 0;

        // Find the price elements
        this.priceElement = this.querySelector("[data-add-to-cart-price]");
        this.comparePriceElement = this.querySelector("[data-compared-price]");

        // Update the price display
        document.addEventListener("change", this.calculatePrice.bind(this));
      }
      calculatePrice() {
        const quantity = this.form.querySelector('[name="quantity"]') || {
          value: 1,
        };
        const price = this.form.querySelector("[data-add-to-cart-price]");
        let comparedPrice = this.form.querySelector("[data-compared-price]");

        const priceAmount = parseFloat(price.dataset.amount);
        let comparedPriceAmount = parseFloat(comparedPrice.dataset.amount);

        if (!quantity || !priceAmount) return;

        if (comparedPriceAmount === 0 || comparedPriceAmount === undefined) {
          comparedPriceAmount = priceAmount;
        }

        const quantityValue = parseInt(quantity.value);

        console.log(quantityValue, priceAmount, comparedPriceAmount);

        let totalPrice = this.calculateTotalPrice(quantityValue, priceAmount);
        let comparedTotalPrice = quantityValue * comparedPriceAmount;

        this.updateMainPrices(
          totalPrice,
          comparedTotalPrice,
          price,
          comparedPrice
        );
        this.updateSubscriptionWidgetsPrices(quantityValue);
        this.updateScalapayInstallments(priceAmount, quantityValue);
      }

      calculateTotalPrice(quantity, basePrice) {
        let total = quantity * basePrice;

        const boxUpsellPrice = this.getBoxUpsellPrice();
        if (boxUpsellPrice) {
          total += quantity * boxUpsellPrice;
        }

        const bundleReduction = this.getQuantityBundleReduction();
        if (bundleReduction) {
          total -= bundleReduction;
        }

        return total;
      }

      getBoxUpsellPrice() {
        const boxUpsell = document.querySelector("box-upsell");
        if (boxUpsell) {
          const itsChecked = boxUpsell.querySelector('[name="selected"]');
          if (itsChecked && itsChecked.checked) {
            return parseFloat(boxUpsell.getAttribute("data-price"));
          }
        }
        return 0;
      }

      getQuantityBundleReduction() {
        const quantityBundle = document.querySelector("quantity-bundle");
        if (quantityBundle) {
          const selectedBundle = quantityBundle.querySelector(".selected");
          if (selectedBundle) {
            return parseFloat(selectedBundle.getAttribute("reduction")) * 100;
          }
        }
        return 0;
      }

      updateMainPrices(
        totalPrice,
        comparedTotalPrice,
        priceElement,
        comparedPriceElement
      ) {
        priceElement.innerHTML = this.formatMoney(totalPrice);

        if (comparedPriceElement) {
          comparedPriceElement.innerHTML = this.formatMoney(comparedTotalPrice);
          comparedPriceElement.classList.toggle(
            "hidden",
            totalPrice >= comparedTotalPrice
          );
        }
      }

      updateSubscriptionWidgetsPrices(quantity) {
        const subscriptionWidgets = document.querySelectorAll(
          ".subscription-widget"
        );
        subscriptionWidgets.forEach((widget) => {
          const price = widget.querySelector(".price__regular");
          const comparePrice = widget.querySelector(".price__discount");

          if (price) {
            const priceAmount = parseFloat(
              price.getAttribute("data-price-amount")
            );
            price.innerHTML = this.formatMoney(priceAmount * quantity);
          }

          if (comparePrice) {
            const comparePriceAmount = parseFloat(
              comparePrice.getAttribute("data-compare-price-amount")
            );
            comparePrice.innerHTML = this.formatMoney(
              comparePriceAmount * quantity
            );
          }
        });
      }

      updateScalapayInstallments(priceAmount, quantity) {
        const scalapayPayInstallments = document.querySelector(
          "scalapay-pay-installments"
        );
        if (scalapayPayInstallments) {
          scalapayPayInstallments.changePrice(
            this.formatMoney((priceAmount * quantity) / 3)
          );
          scalapayPayInstallments.toggle();
        }
      }

      formatMoney(amount) {
        return Shopify.formatMoney(amount, "{{amount}}$", Shopify.currency);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
